<script setup>
	import { defineProps } from 'vue'

	const props = defineProps({
        item: Object,
        required: true
    })
</script>

<template>
	<div class="establishment">
      <img 
        v-lazy="{ 
            src: item.business_logo, 
            loading: 'img/image_loader.gif', 
            error: 'img/no_image.png' 
        }"
      />
      <div class="grow mx-2">
        <h2>{{ item.business_name }}</h2>
      </div>
      <img src="img/chevron.png"/>
    </div>
</template>

<style scoped>
	/*
    **ESTABLISHMENT CARD
    */
    .establishment {
        @apply bg-white dark:bg-zinc-700 p-4 m-4 rounded-[37px] items-center flex shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50 border border-zinc-200/50 dark:border-zinc-900/50;
    }

    .establishment h2 {
        @apply font-bold;
    }

    .establishment p {
        @apply font-thin text-xs text-zinc-400;
    }

    .establishment img:first-child {
        @apply w-[40px] h-[40px] rounded-full object-cover shadow-md shadow-zinc-200/50 dark:shadow-zinc-900/50;
    }
</style>